export const getFileType = (url: string): "image" | "video" => {
  const ext = url.split(".").pop() || "";
  if (["mp4", "mov"].includes(ext)) return "video";
  return "image";
};

export const downloadFile = (filename: string, url: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
